import {experimentation} from '@microsoft/office-experimentation-web';
import {CHANGE_GATE_PREFIX} from '../AppConstants';

// List of change gates
export const isUseCustomIconServer = experimentation.getBooleanFeatureGate(
  CHANGE_GATE_PREFIX + 'isUseCustomIconServer',
  true,
);
